import {DeliveryCondition, IDeliveryConditionDto} from '@lib/delivery-conditions';
import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EnvService} from '@lib/env';
import {catchError, map, Observable, of} from 'rxjs';
import {UriBuilder} from 'uribuilder';
import {I18nService} from '@lib/i18n';
import {HttpCacheKeyPrefix, HttpExtras} from '@lib/core';

@Injectable({
    providedIn: 'root',
})
export class BasketSupplierDeliveryConditionsDataService {
    http = inject(HttpClient);
    env = inject(EnvService);
    i18n = inject(I18nService);

    public getConditionFor(supplierId: string): Observable<DeliveryCondition | undefined> {
        const uri: UriBuilder = this.env.getBase('basket-delivery-condition', supplierId);

        return this.http.get<IDeliveryConditionDto | undefined>(uri.toString(), {params: HttpExtras.CACHE_KEY_PREFIX(HttpCacheKeyPrefix.BASKET_DELIVERY_CONDITION)}).pipe(
            map((dto: IDeliveryConditionDto | undefined) => {
                if (dto) {
                    return new DeliveryCondition(dto, this.i18n);
                }

                return undefined;
            }),
            catchError((error) => {
                console.error('Error in HTTP request:', error);
                return of(undefined);  // Return a default value or handle error gracefully
            })
        );
    }

    public deleteCondition(supplierId: string): Observable<void> {
        const uri: UriBuilder = this.env.getBase('basket-delivery-condition', supplierId);

        return this.http.delete<void>(uri.toString(), {params: HttpExtras.PRUNE_CACHE_WITH_PREFIX(HttpCacheKeyPrefix.BASKET_DELIVERY_CONDITION)});
    }

    public update(supplierId: string, conditionId: string): Observable<DeliveryCondition | undefined> {
        const uri: UriBuilder = this.env.getBase('basket-delivery-condition', supplierId, conditionId);

        return this.http.put<IDeliveryConditionDto | undefined>(uri.toString(), {}, {params: HttpExtras.PRUNE_CACHE_WITH_PREFIX(HttpCacheKeyPrefix.BASKET_DELIVERY_CONDITION)}).pipe(
            map((dto: IDeliveryConditionDto | undefined) => {
                if (dto) {
                    return new DeliveryCondition(dto, this.i18n);
                }

                return undefined;
            }),
            catchError((error) => {
                console.error('Error in HTTP request:', error);
                return of(undefined);  // Return a default value or handle error gracefully
            })
        );
    }
}
